<template>
  <div class="overflow-x-auto px-5">
    <div class="flex items-center justify-between mb-3.5">
      <h3 class="text-xl font-poppins font-semibold">Students Activity</h3>
      <button @click="handleOpenExportDataModal()" class="sample bg-primary hover:bg-primary-dark text-white rounded px-4 py-2 h-9"  >
        Export Data
      </button>
    </div>
    <table class="w-full mb-5">
      <thead>
        <tr>
          <td class="font-semibold cursor-pointer w-1/5">
            <div class="flex justify-center">Student Name</div>
          </td>
          <td colspan="7" class="tap-in font-semibold">
            <div class="flex justify-center">Tap Ins</div>
          </td>
          <td :colspan="assessmentsColspan + 2" class="feedback font-semibold">
            <div class="flex justify-center">Assessment</div>
          </td>
        </tr>
        <tr class="font-semibold">
          <td>
            <div class="flex justify-center">
              <select
                v-model="selectedOrderList"
                class="px-3 py-1.5 text-sm font-normal text-gray-700 bg-white focus:text-gray-700 cursor-pointer focus:outline-none border rounded border-blueGray"
              >
                <option value="name-asc">Name A-Z</option>
                <option value="name-desc">Name Z-A</option>
                <option value="last-name-desc">Last Name Z-A</option>
                <option value="last-name-asc">Last Name A-Z</option>
              </select>
            </div>
          </td>
          <td
            class="tap-in cursor-pointer"
            @click="sortByClick('time_as_speaker')"
          >
            <div class="flex items-center space-x-2">
              <span>Time as Speaker</span>
              <i
                :class="
                  !dataTableCaretAscTime_as_speaker
                    ? 'fa-angle-up'
                    : 'fa-angle-down'
                "
                class="fa-solid"
              ></i>
            </div>
          </td>
          <td class="tap-in cursor-pointer" @click="sortByClick('TapInsTotal')">
            <div class="flex items-center space-x-2">
              <span>#Total</span>
              <i
                :class="
                  dataTableCaretAscTapInsTotal ? 'fa-angle-up' : 'fa-angle-down'
                "
                class="fa-solid"
              ></i>
            </div>
          </td>
          <td class="tap-in cursor-pointer" @click="sortByClick('New_idea')">
            <div class="flex items-center space-x-2">
              <span>New Idea</span>
              <i
                :class="
                  !dataTableCaretAscNewIdea ? 'fa-angle-up' : 'fa-angle-down'
                "
                class="fa-solid"
              ></i>
            </div>
          </td>
          <td class="tap-in cursor-pointer" @click="sortByClick('Build_on')">
            <div class="flex items-center space-x-2">
              <span>Build On</span>
              <i
                :class="
                  !dataTableCaretAscBuildOn ? 'fa-angle-up' : 'fa-angle-down'
                "
                class="fa-solid"
              ></i>
            </div>
          </td>
          <td class="tap-in cursor-pointer" @click="sortByClick('Challenge')">
            <div class="flex items-center space-x-2">
              <span>Challenge</span>
              <i
                :class="
                  !dataTableCaretAscChallenge ? 'fa-angle-up' : 'fa-angle-down'
                "
                class="fa-solid"
              ></i>
            </div>
          </td>
          <td class="tap-in cursor-pointer" @click="sortByClick('Question')">
            <div class="flex items-center space-x-2">
              <span>Question</span>
              <i
                :class="
                  !dataTableCaretAscQuestion ? 'fa-angle-up' : 'fa-angle-down'
                "
                class="fa-solid"
              ></i>
            </div>
          </td>
          <td class="tap-in cursor-pointer" @click="sortByClick('Teacher')">
            <div class="flex items-center space-x-2">
              <span>Teacher</span>
              <i
                :class="
                  !dataTableCaretAscTeacher ? 'fa-angle-up' : 'fa-angle-down'
                "
                class="fa-solid"
              ></i>
            </div>
          </td>
          <td v-for="a in assessments" :key="a.title" class="feedback px-1">
            {{ a.title }}
          </td>
          <td
            class="feedback cursor-pointer px-1"
            @click="sortByClick('TotalPoint')"
          >
            <div class="flex items-center space-x-2">
              <span>Total Points</span>
              <i
                :class="
                  !dataTableCaretAscTotalPoint ? 'fa-angle-up' : 'fa-angle-down'
                "
                class="fa-solid"
              ></i>
            </div>
          </td>
          <td class="feedback cursor-pointer" @click="sortByClick('Feedback')">
            <div class="flex items-center space-x-2">
              <span>Written Feedback</span>
              <i
                :class="
                  !dataTableCaretAscFeedback ? 'fa-angle-up' : 'fa-angle-down'
                "
                class="fa-solid"
              ></i>
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(participant, index) in data_table" :key="index">
          <td>
            <div class="flex items-center">
              <img
                :src="participant.image"
                class="rounded-full mr-2 h-9 w-9"
                alt="avatar"
              />
              <span
                @click="sortByClick('StudentName')"
                class="truncate"
                :title="participant.name"
              >
                {{ participant.name }}
              </span>
            </div>
          </td>
          <td class="tap-in">
            {{ formatTime(participant.time_spent_as_current_speaker) }}
          </td>
          <td class="tap-in">{{ participant.total_contributions }}</td>
          <td class="tap-in">{{ participant.new_idea }}</td>
          <td class="tap-in">{{ participant.build_on }}</td>
          <td class="tap-in">{{ participant.challenge }}</td>
          <td class="tap-in">{{ participant.question }}</td>
          <td class="tap-in">{{ participant.hand_raise }}</td>
          <td
            v-if="!participant.assessments.length"
            v-for="a in assessments"
            :key="a.title"
            class="feedback"
          >
            -
          </td>
          <td
            v-for="s in participant.assessments"
            :key="s.title"
            class="feedback"
          >
            {{ s.value }}
          </td>
          <td v-if="!participant.assessments.length" class="feedback">-</td>
          <td v-else class="feedback">{{ participant.total_points }}</td>
          <td class="feedback">
            <div
              v-if="participant.teacher_feedback !== ''"
              @click="redirectToStudentFeedback(participant)"
              class="flex justify-center hover:underline text-green-500 cursor-pointer"
            >
              Sent
            </div>
            <div
              v-else-if="participant.draft_teacher_feedback !== ''"
              @click="redirectToStudentFeedback(participant)"
              class="flex justify-center hover:underline cursor-pointer"
            >
              Draft
            </div>
            <div v-else class="flex justify-center">-</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import { EventBus } from '../../utils/event-bus';
  import GenerateExportableData from 'services/liveDiscussion/generateExportableData';
  import LiveDiscussionService from 'services/liveDiscussion';

  export default Vue.extend({
    components: {
      ExportEngagementDataModal: () =>
        import('components/modals/exportEngagementDataModal'),
    },
    data() {
      return {
        dataTableCaretAscStudentsNames: true,
        // dataTableCaretAscTimeTappedIn: false,
        dataTableCaretAscTime_as_speaker: false,
        dataTableCaretAscTapInsTotal: false,
        dataTableCaretAscNewIdea: false,
        dataTableCaretAscBuildOn: false,
        dataTableCaretAscChallenge: false,
        dataTableCaretAscQuestion: false,
        dataTableCaretAscTeacher: false,
        dataTableCaretAscFeedback: false,
        dataTableCaretAscTotalPoint: false,
        //dataTableSorted: [],
        show_export_data_modal: false,
        data: null,
        selectedOrderList: 'name-asc',
        data_table: [],
      };
    },
    watch: {
      selectedOrderList: function (newValue) {
        if (newValue === 'name-asc') {
          this.data_table.sort((a, b) => a.name.localeCompare(b.name));
          return;
        }
        if (newValue === 'name-desc') {
          this.data_table.sort((a, b) => b.name.localeCompare(a.name));
          return;
        }
        if (newValue === 'last-name-desc') {
          let students = [];
          this.data_table.forEach((student) => {
            var lastName = student.name.split(' ').slice(-1).join(' ');
            student.lastName = lastName;
            students.push(student);
          });
          this.data_table = students;
          this.data_table.sort((a, b) => b.lastName.localeCompare(a.lastName));
          return;
        }
        if (newValue === 'last-name-asc') {
          let students = [];
          this.data_table.forEach((student) => {
            var lastName = student.name.split(' ').slice(-1).join(' ');
            student.lastName = lastName;
            students.push(student);
          });
          this.data_table = students;
          this.data_table.sort((a, b) => a.lastName.localeCompare(b.lastName));
          return;
        }
      },
    },
    computed: {
      ...mapGetters(['getCurrentDiscussion', 'getClassSummaryLD']),
      exportable_file_name() {
        const date = moment().format('L'); // MM-DD-YYYY
        const fileName = `${this.getCurrentDiscussion.title} - Verbal - Export ${date}.csv`;
        return fileName;
      },
      assessments() {
        if (this.getCurrentDiscussion.enable_grading)
          return this.getCurrentDiscussion.points_settings.peer_rewards;
        return [];
      },
      assessmentsColspan() {
        if (this.getCurrentDiscussion.enable_grading)
          return this.getCurrentDiscussion.points_settings.peer_rewards.length;
        return [];
      },
    },
    methods: {
      sortByClick(sort) {
        switch (sort) {
          case 'time_as_speaker':
            if (this.dataTableCaretAscTime_as_speaker) {
              this.data_table.sort(
                (a, b) =>
                  b.time_spent_as_current_speaker -
                  a.time_spent_as_current_speaker
              );
              this.dataTableCaretAscTime_as_speaker = false;
              break;
            }
            this.data_table.sort(
              (a, b) =>
                a.time_spent_as_current_speaker -
                b.time_spent_as_current_speaker
            );
            this.dataTableCaretAscTime_as_speaker = true;
            break;
          case 'TapInsTotal':
            if (this.dataTableCaretAscTapInsTotal) {
              this.data_table.sort(
                (a, b) => b.total_contributions - a.total_contributions
              );
              this.dataTableCaretAscTapInsTotal = false;
              break;
            }
            this.data_table.sort(
              (a, b) => a.total_contributions - b.total_contributions
            );
            this.dataTableCaretAscTapInsTotal = true;
            break;
          case 'New_idea':
            if (this.dataTableCaretAscNewIdea) {
              this.data_table.sort((a, b) => b.new_idea - a.new_idea);
              this.dataTableCaretAscNewIdea = false;
              break;
            }
            this.data_table.sort((a, b) => a.new_idea - b.new_idea);
            this.dataTableCaretAscNewIdea = true;
            break;
          case 'Build_on':
            if (this.dataTableCaretAscBuildOn) {
              this.data_table.sort((a, b) => b.build_on - a.build_on);
              this.dataTableCaretAscBuildOn = false;
              break;
            }
            this.data_table.sort((a, b) => a.build_on - b.build_on);
            this.dataTableCaretAscBuildOn = true;
            break;
          case 'Challenge':
            if (this.dataTableCaretAscChallenge) {
              this.data_table.sort((a, b) => b.challenge - a.challenge);
              this.dataTableCaretAscChallenge = false;
              break;
            }
            this.data_table.sort((a, b) => a.challenge - b.challenge);
            this.dataTableCaretAscChallenge = true;
            break;
          case 'Question':
            if (this.dataTableCaretAscQuestion) {
              this.data_table.sort((a, b) => b.question - a.question);
              this.dataTableCaretAscQuestion = false;
              break;
            }
            this.data_table.sort((a, b) => a.question - b.question);
            this.dataTableCaretAscQuestion = true;
            break;
          case 'Teacher':
            if (this.dataTableCaretAscTeacher) {
              this.data_table.sort((a, b) => b.hand_raise - a.hand_raise);
              this.dataTableCaretAscTeacher = false;
              break;
            }
            this.data_table.sort((a, b) => a.hand_raise - b.hand_raise);
            this.dataTableCaretAscTeacher = true;
            break;
          case 'Feedback':
            if (this.dataTableCaretAscFeedback) {
              this.data_table.sort((a, b) =>
                a.teacher_feedback.localeCompare(b.teacher_feedback)
              );
              this.dataTableCaretAscFeedback = false;
              break;
            }
            this.data_table.sort((a, b) =>
              b.teacher_feedback.localeCompare(a.teacher_feedback)
            );
            this.dataTableCaretAscFeedback = true;
            break;
          case 'TotalPoint':
            if (this.dataTableCaretAscTotalPoint) {
              this.data_table.sort((a, b) => b.total_points - a.total_points);
              this.dataTableCaretAscTotalPoint = false;
              break;
            }
            this.data_table.sort((a, b) => a.total_points - b.total_points);
            this.dataTableCaretAscTotalPoint = true;
            break;
          default:
            this.data_table.sort((a, b) => a.name.localeCompare(b.name));
        }
      },
      fetchClassCSVdata() {
        return GenerateExportableData(this.getCurrentDiscussion.id).then(
          (res) => res.data
        );
      },
      formatTime: function (ms) {
        let duration = moment.duration(ms, 'milliseconds');
        const seconds = duration.seconds();
        const minutes = duration.minutes();
        const hours = parseInt(duration.asHours());
        return (
          (hours < 10 ? '0' + hours : hours) +
          'h ' +
          (minutes < 10 ? '0' + minutes : minutes) +
          'm ' +
          (seconds < 10 ? '0' + seconds : seconds) +
          's'
        );
      },
      redirectToStudentFeedback: async function (participation) {
        const participationStudent =
          this.getCurrentDiscussion.participations.find(
            (p) => p.id === participation.participation_id
          );
        EventBus.$emit(
          'openAssessmentStudent',
          participationStudent,
          'discussion'
        );
      },
      handleOpenExportDataModal: function() {
        EventBus.$emit('handleOpenExportData');
      }
    },
    mounted: async function () {
      /* Se já tivermos acesso a esta informação e mandar como props do summary tab */
      const summaryData = await LiveDiscussionService.getSummaryTableData(
        this.getCurrentDiscussion.id
      );
      this.data_table = summaryData.data;
      this.data_table.sort((a, b) => a.name.localeCompare(b.name));
    },
  });
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl'

  table, td, th {
    border: 1px solid lightgray
    border-collapse: collapse
    padding: 12px
  }

  .tap-in
    background-color: rgba(194, 234, 240, .25)

  .feedback
    background-color: rgba(205, 250, 221,0.25)

  .grid-cell
    display: flex;
    justify-content: center
    align-items: center
    text-align: center

  .link-student-feedback
    color: #78D874
    cursor: pointer

  .avatar-size
    width: 36px
    height: 36px
    img
      height: 100%

  .avatar-circlex
    border-radius: 50%
    background-color: pl-fog
</style>



// WEBPACK FOOTER //
// individualSummaryOverlay.vue?c6b429f4